module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/couch-0729ec648d53d02c36caf4fb88571a6b.svg";